import PropTypes from 'prop-types';
import Slider from 'react-slick';
// @mui
import { Box, Card } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
// components
import Image from '../../components/Image';
import { CarouselDots } from '../../components/carousel';

// ----------------------------------------------------------------------
const data = [
  {
    id: 2,
    image: '/slider/lo-trinh-hoc-xe-may.jpg',
  }
];
const OverlayStyle = styled('div')(({ theme }) => ({
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 8,
  position: 'absolute',
  backgroundColor: alpha(theme.palette.grey[500], 0.1),
}));

// ----------------------------------------------------------------------

export default function MotorSlider() {
  const settings = {
    speed: 1000,
    dots: true,
    arrows: false,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    ...CarouselDots({ position: 'absolute', right: 24, bottom: 24 }),
  };

  return (
    <Card>
      <Slider {...settings}>
        {data.map((item) => (
          <CarouselItem key={item.id} item={item} />
        ))}
      </Slider>
    </Card>
  );
}

// ----------------------------------------------------------------------

CarouselItem.propTypes = {
  item: PropTypes.shape({
    image: PropTypes.string,
    name: PropTypes.string,
  }),
};

function CarouselItem({ item }) {
  const { image, name } = item;

  return (
    <Box sx={{ position: 'relative' }}>
      <OverlayStyle />
      <Image alt={name} src={image} ratio={"16/8"} />
    </Box>
  );
}
